var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.561 5.346 7.455.183c.257-.27.446-.216.652 0l.052.054c.206.217.257.434 0 .686l-5.272 5.56c-.257.271-.446.217-.652 0L.175 4.317c-.258-.27-.207-.47 0-.686l.05-.054c.207-.217.413-.27.653 0l1.683 1.77Z",
    fill: "#1E1E1E"
  })));
};
export default SvgCheck;